import React from 'react'
import i18next from 'i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { WithdrawalDetailsType } from 'types/transaction'

interface WithdrawalDetailsProps {
  withdrawalDetails: WithdrawalDetailsType
}

const WithdrawalDetails = ({ withdrawalDetails }: WithdrawalDetailsProps) => {
  const THIRD_PARTY = 'THIRD_PARTY'

  return (
    <>
      <p className="text-h4 text-foreground-prominent mt-3">
        {withdrawalDetails?.beneficiary.type === THIRD_PARTY
          ? i18next.t('transactions.sideBar.beneficiaryDetails')
          : i18next.t('withdrawalDetails')}
      </p>
      <Box gapY={8}>
        {!!withdrawalDetails?.beneficiary?.accountNumber && (
          <DataListItem
            id="account-number"
            testId="account-number"
            title={i18next.t('accountNumber')}
            body={withdrawalDetails?.beneficiary?.accountNumber}
          />
        )}
        {!!withdrawalDetails?.beneficiary?.bankName && (
          <DataListItem
            id="bank-name"
            testId="bank-name"
            title={i18next.t('bankName')}
            body={withdrawalDetails?.beneficiary?.bankName}
          />
        )}
        {!!withdrawalDetails?.beneficiary?.bankCode && (
          <DataListItem
            id="bank-code"
            testId="bank-code"
            title={i18next.t('bankCode')}
            body={withdrawalDetails?.beneficiary?.bankCode}
          />
        )}
        {!!withdrawalDetails?.beneficiary?.name && (
          <DataListItem
            id="beneficiary-name"
            testId="beneficiary-name"
            title={i18next.t('beneficiaryName')}
            body={withdrawalDetails?.beneficiary?.name}
          />
        )}
      </Box>
    </>
  )
}

export default WithdrawalDetails
